import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cube-loader',
  templateUrl: './cube-loader.component.html',
  styleUrls: ['./cube-loader.component.scss']
})
export class CubeLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
